import React, { useState } from 'react';
import { Loader, TrendingUp, Clock, X } from "lucide-react";
import { useIsMobile } from '../../hooks/use-mobile';

const AIBanner = ({ hoursSaved, isLoading }) => {
  const isMobile = useIsMobile();
  const [isVisible, setIsVisible] = useState(true);

  const roundedHoursSaved = Math.floor(hoursSaved + 0.5);

  if (!isVisible) return null;
  
  return (
    <div className="bg-gradient-to-r from-[#6366F1] to-[#8b5cf6] text-white p-4 md:p-6 mb-4 rounded-lg shadow-md relative">
      <button 
        onClick={() => setIsVisible(false)}
        className="absolute top-1 right-1 z-10 p-1 rounded-full bg-white/20 hover:bg-white/30 transition-colors"
        aria-label="Close banner"
      >
        <X className="h-3 w-3 md:h-4 md:w-4" />
      </button>
      
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-3 md:gap-4">
        <div className="flex items-start gap-2 md:gap-3">
          <div className="p-1.5 md:p-2 bg-white/20 rounded-full">
            {isLoading ? <Loader className="h-5 w-5 md:h-6 md:w-6 animate-spin" /> : <TrendingUp className="h-5 w-5 md:h-6 md:w-6" /> }
          </div>
          <div>
            <h3 className="text-lg md:text-xl font-bold mb-0.5 md:mb-1">AI-Powered Efficiency</h3>
            {hoursSaved && (<p className="text-white/90 text-sm md:text-base">
              {isMobile ?
                `${roundedHoursSaved} Hours saved from AI Self-Service.` :
                `In the past month, you saved ${roundedHoursSaved} Hours from AI Self-Service Resolutions.`}
            </p>)}
          </div>
        </div>
        <div className="flex items-center gap-1.5 md:gap-2 bg-white/20 px-3 md:px-4 py-1.5 md:py-2 rounded-lg mt-2 md:mt-0">
          <Clock className="h-4 w-4 md:h-5 md:w-5" />
          {hoursSaved && (<span className="text-sm md:text-base font-medium">{roundedHoursSaved} hours saved this month</span>)}
        </div>
      </div>
    </div>
  );
};

export default AIBanner;